import React from 'react';

const EmptyListDataProcessing = (props: any) => {
  return (
    <svg width="185" height="140" viewBox="0 0 185 140" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect opacity="0.5" x="31.8082" y="15.0068" width="108.384" height="108.384" rx="9.42466" fill="#FAFAFA" />
      <g filter="url(#filter0_bf_1948_12965)">
        <rect x="15" y="24" width="103.28" height="75.2883" rx="3.86094" fill="white" fill-opacity="0.9" />
        <rect x="24.1697" y="33.1697" width="27.0266" height="2.8957" rx="1.44785" fill="#F0F0F0" />
        <rect x="24.1697" y="84.3291" width="5.41582" height="5.41582" rx="2.70791" fill="#B5DCFC" />
        <rect x="32.2935" y="85.6816" width="14.8935" height="2.70791" rx="1.35395" fill="#F0F0F0" />
        <rect x="56.673" y="84.3271" width="5.41582" height="5.41582" rx="2.70791" fill="#84C5FA" />
        <rect x="64.7967" y="85.6797" width="9.929" height="2.70791" rx="1.35395" fill="#F0F0F0" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21 60.2539C21 50.7851 28.1803 43.0002 37.372 42.0892C37.9432 42.0325 38.4222 42.4958 38.4222 43.0721V50.2832C38.4222 50.8107 38.0174 51.244 37.5011 51.3415C33.315 52.1314 30.1477 55.8213 30.1477 60.2539C30.1477 63.4928 31.8388 66.3352 34.3827 67.9394C34.8504 68.2343 35.0662 68.8273 34.8328 69.3299L31.8166 75.8246C31.5796 76.3348 30.9724 76.5559 30.4803 76.2862C24.8318 73.1896 21 67.1711 21 60.2539Z"
          fill="#84C5FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.2126 76.2685C32.964 76.8039 33.2213 77.441 33.7834 77.6151C35.4795 78.1405 37.2816 78.4234 39.1495 78.4234C49.1899 78.4234 57.3292 70.2508 57.3292 60.1695C57.3292 50.7007 50.1489 42.9157 40.9572 42.0047C40.386 41.9481 39.907 42.4113 39.907 42.9877V50.1987C39.907 50.7263 40.3118 51.1595 40.8281 51.257C45.0142 52.047 48.1815 55.7368 48.1815 60.1695C48.1815 65.178 44.1377 69.2383 39.1495 69.2383C38.5799 69.2383 38.0227 69.1853 37.4823 69.0841C36.9934 68.9925 36.4871 69.2178 36.2769 69.6704L33.2126 76.2685Z"
          fill="#B5DCFC"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M72 60.2539C72 50.7851 79.1803 43.0002 88.372 42.0892C88.9432 42.0325 89.4222 42.4958 89.4222 43.0721V50.2832C89.4222 50.8107 89.0174 51.244 88.5011 51.3415C84.315 52.1314 81.1477 55.8213 81.1477 60.2539C81.1477 63.4928 82.8388 66.3352 85.3827 67.9394C85.8504 68.2343 86.0662 68.8273 85.8328 69.3299L82.8166 75.8246C82.5796 76.3348 81.9724 76.5559 81.4803 76.2862C75.8318 73.1896 72 67.1711 72 60.2539Z"
          fill="#84C5FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M84.2126 76.2685C83.964 76.8039 84.2213 77.441 84.7834 77.6151C86.4795 78.1405 88.2816 78.4234 90.1495 78.4234C100.19 78.4234 108.329 70.2508 108.329 60.1695C108.329 50.7007 101.149 42.9157 91.9572 42.0047C91.386 41.9481 90.907 42.4113 90.907 42.9877V50.1987C90.907 50.7263 91.3118 51.1595 91.8281 51.257C96.0142 52.047 99.1815 55.7368 99.1815 60.1695C99.1815 65.178 95.1377 69.2383 90.1495 69.2383C89.5799 69.2383 89.0227 69.1853 88.4823 69.0841C87.9934 68.9925 87.4871 69.2178 87.2769 69.6704L84.2126 76.2685Z"
          fill="#B5DCFC"
        />
        <rect
          x="14.7587"
          y="23.7587"
          width="103.763"
          height="75.7709"
          rx="4.10225"
          stroke="url(#paint0_linear_1948_12965)"
          stroke-width="0.482617"
        />
      </g>
      <g filter="url(#filter1_d_1948_12965)">
        <rect x="66" y="48.7114" width="103" height="29.8345" rx="5.68276" fill="white" />
        <rect
          x="66.1776"
          y="48.889"
          width="102.645"
          height="29.4793"
          rx="5.50517"
          stroke="url(#paint1_linear_1948_12965)"
          stroke-width="0.355173"
        />
      </g>
      <rect x="95.8345" y="61" width="59.669" height="5.68276" rx="2.84138" fill="#B5DCFC" />
      <g clip-path="url(#clip0_1948_12965)">
        <rect x="73.8138" y="55.1045" width="17.0483" height="17.0483" rx="4.26207" fill="#B5DCFC" />
        <path
          opacity="0.7"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M84.3868 59.833C85.5481 60.9943 85.5481 62.8773 84.3868 64.0387C83.2254 65.2001 81.3424 65.2001 80.181 64.0387C79.0196 62.8773 79.0196 60.9943 80.181 59.833C81.3424 58.6716 83.2254 58.6716 84.3868 59.833Z"
          fill="white"
          stroke="white"
          stroke-width="1.20593"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.7"
          d="M89.2142 71.0211C89.2142 71.1931 89.2171 71.3573 89.2199 71.5151C89.2271 71.9188 89.2335 72.2805 89.1885 72.6249C89.1287 73.0825 88.981 73.4634 88.6331 73.7839C88.2757 74.1132 87.677 74.4065 86.6572 74.6148C85.6398 74.8226 84.2305 74.9404 82.2801 74.9404C80.482 74.9404 79.1482 74.8227 78.1589 74.6151C77.1687 74.4072 76.5437 74.1132 76.1435 73.7753C75.3622 73.1155 75.346 72.214 75.346 71.0211C75.346 70.0073 76.0526 69.0337 77.3157 68.2969C78.5713 67.5645 80.3258 67.1018 82.2801 67.1018C84.2344 67.1018 85.9889 67.5645 87.2445 68.2969C88.5076 69.0337 89.2142 70.0073 89.2142 71.0211Z"
          fill="white"
          stroke="white"
          stroke-width="0.602967"
        />
      </g>
      <g filter="url(#filter2_d_1948_12965)">
        <rect x="66" y="82.7114" width="103" height="29.8345" rx="5.68276" fill="white" />
        <rect
          x="66.1776"
          y="82.889"
          width="102.645"
          height="29.4793"
          rx="5.50517"
          stroke="url(#paint2_linear_1948_12965)"
          stroke-width="0.355173"
        />
      </g>
      <rect x="95.8345" y="95" width="59.669" height="5.68276" rx="2.84138" fill="#B5DCFC" />
      <g clip-path="url(#clip1_1948_12965)">
        <rect x="73.8138" y="89.1045" width="17.0483" height="17.0483" rx="4.26207" fill="#B5DCFC" />
        <path
          opacity="0.7"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M84.3868 93.833C85.5481 94.9943 85.5481 96.8773 84.3868 98.0387C83.2254 99.2001 81.3424 99.2001 80.181 98.0387C79.0196 96.8773 79.0196 94.9943 80.181 93.833C81.3424 92.6716 83.2254 92.6716 84.3868 93.833Z"
          fill="white"
          stroke="white"
          stroke-width="1.20593"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.7"
          d="M89.2142 105.021C89.2142 105.193 89.2171 105.357 89.2199 105.515C89.2271 105.919 89.2335 106.28 89.1885 106.625C89.1287 107.082 88.981 107.463 88.6331 107.784C88.2757 108.113 87.677 108.406 86.6572 108.615C85.6398 108.823 84.2305 108.94 82.2801 108.94C80.482 108.94 79.1482 108.823 78.1589 108.615C77.1687 108.407 76.5437 108.113 76.1435 107.775C75.3622 107.115 75.346 106.214 75.346 105.021C75.346 104.007 76.0526 103.034 77.3157 102.297C78.5713 101.564 80.3258 101.102 82.2801 101.102C84.2344 101.102 85.9889 101.564 87.2445 102.297C88.5076 103.034 89.2142 104.007 89.2142 105.021Z"
          fill="white"
          stroke="white"
          stroke-width="0.602967"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_1948_12965"
          x="10.715"
          y="19.7149"
          width="111.85"
          height="83.8585"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.90122" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1948_12965" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1948_12965" result="shape" />
          <feGaussianBlur stdDeviation="1.5" result="effect2_foregroundBlur_1948_12965" />
        </filter>
        <filter
          id="filter1_d_1948_12965"
          x="50.6777"
          y="41.0503"
          width="133.645"
          height="60.4791"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="7.66116" />
          <feGaussianBlur stdDeviation="7.66116" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0430208 0 0 0 0 0.264631 0 0 0 0 0.448646 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1948_12965" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1948_12965" result="shape" />
        </filter>
        <filter
          id="filter2_d_1948_12965"
          x="58"
          y="78.7114"
          width="119"
          height="45.8345"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0430208 0 0 0 0 0.264631 0 0 0 0 0.448646 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1948_12965" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1948_12965" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_1948_12965"
          x1="15.7123"
          y1="26.6889"
          x2="103.922"
          y2="110.008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F0F0F0" />
          <stop offset="0.533997" stop-color="#FAFAFA" />
          <stop offset="1" stop-color="#F0F0F0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1948_12965"
          x1="66.7103"
          y1="49.7769"
          x2="91.7382"
          y2="109.272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F0F0F0" />
          <stop offset="0.533997" stop-color="#FAFAFA" />
          <stop offset="1" stop-color="#F0F0F0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1948_12965"
          x1="66.7103"
          y1="83.7769"
          x2="91.7382"
          y2="143.272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F0F0F0" />
          <stop offset="0.533997" stop-color="#FAFAFA" />
          <stop offset="1" stop-color="#F0F0F0" />
        </linearGradient>
        <clipPath id="clip0_1948_12965">
          <rect width="17.0483" height="17.0483" fill="white" transform="translate(73.8138 55.1045)" />
        </clipPath>
        <clipPath id="clip1_1948_12965">
          <rect width="17.0483" height="17.0483" fill="white" transform="translate(73.8138 89.1045)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EmptyListDataProcessing;
